import { UnifiedRolesEditorResolver } from '../domains/UnifiedRoles/domain/policies/UnifiedRolesEditorResolver';

export const DISPLAY_SUCCESSFUL_SWITCH_TENANT_TOASTER =
  '@project44/um-ui/display-successful-switch-tenant-toaster';

export const UPDATE_USER_QUERY = '@project44/um-ui/update-user-query';

export const IAM_3542_DISABLE_UM_UI_NMC_ROLE_SUPPORT =
  UnifiedRolesEditorResolver.IAM_3542_DISABLE_UM_UI_NMC_ROLE_SUPPORT;
